import type { FaireProductEntity } from "../../entity_types/product";

export const p_s69zu73tc4: FaireProductEntity = {
  token: "p_s69zu73tc4",
  type: "product",
  name: "Boylan Bottling Loose Case Root Beer, 12 Fluid Ounce",
  brandToken: "b_9z8pu8jvce",
  brandName: "Rising Sun Distributors",
  imageUrl:
    "https://cdn.faire.com/fastly/0df416d11ba5dadf11f1ff5a61856aa3815028f570db03c7251d3b0dbb4afffc.jpeg",
  galleryImageUrls: [],
  priceDollars: 2.91,
  description:
    "A premium craft soda with guaranteed shelf appeal and fast repeat sales.\n\nBoylan Root Beer is one of the most recognizable and best-selling craft sodas in the specialty beverage category. Made with cane sugar and a signature blend of sassafras, botanicals, and warm spices, this glass-bottled classic delivers the nostalgic flavor customers love—with a premium look retailers rely on for strong merchandising",
  tags: [],
  msrpDollars: 5.82,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:21.214Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
